import React, { Component } from 'react';
import 모의고사 from '../images/Event/trial/모의고사.png';

class Trial extends Component {
  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont" >
              <div id="contents" style={{background: '#912721'}}>
                <div className="app-header" style={{background: '#912721', border: 'none'}}>
                  <a href="/" className="app-close-white"><span className="blind">닫기</span></a>
                </div>

                <div className="info-cont">
                  <img src={모의고사} style={{width: '100%'}} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Trial;